import React, { memo } from "react";
import * as Styles from "./button.styles";

export const Button = memo((props) => {
  return <Styles.StyledButton {...props}>{props.children}</Styles.StyledButton>;
});
